// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
  factory('travelSpend', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getTotalSpendByDates(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/totalspend/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopCityPairs(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/topcitypairs/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopAirlines(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/topairlines/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopHotelCities(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/tophotelcities/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopCarCities(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/topcarcities/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopHotels(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/tophotels/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getTopCarRentalCompanies(startDate, endDate, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelSpend}/admin/topcarrentalcompanies/${startDate}/${endDate}/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/travelSpend.service.js